import { Bot } from 'lucide-react';
import { PersistedWorkflow } from '@cotera/sdk/core';
import { Text } from '@cotera/client/app/components/ui';
import type { WorkflowNodeRenderStrategy } from '../types';
import {
  agentBodyDescription,
  agentDescription,
  agentIdFromNode,
  agentTitle,
} from '../agent-node-display';

const { WorkflowNodeType } = PersistedWorkflow;

/**
 * Catalog view for agent nodes. Canvas cards use {@link AgentNodeCard}; this
 * body is for non-canvas surfaces (e.g. generic {@link WorkflowNode} fallback).
 */
export const agentNodeStrategy: WorkflowNodeRenderStrategy = {
  nodeType: WorkflowNodeType.Agent,
  accent: 'agent',
  badge: 'Agent',
  getTitle: (node) => agentTitle(node, undefined),
  getDescription: (node) => agentDescription(node, undefined),
  renderIcon: () => <Bot className="h-4 w-4" />,
  renderBody: (node) => {
    const agentId = agentIdFromNode(node);
    if (agentId === undefined) {
      return (
        <Text.Caption className="text-muted-foreground block">
          Agent not set.
        </Text.Caption>
      );
    }
    return (
      <Text.Caption className="text-muted-foreground block line-clamp-2">
        {agentBodyDescription(node, undefined)}
      </Text.Caption>
    );
  },
};
